// frontend/src/components/dashboard/ImageUploadPreview.js
import React, { useState } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

export default function ImageUploadPreview({ onImageSelect, currentImage, isLogo = false }) {
   const [preview, setPreview] = useState(currentImage || null);

   const handleFileSelect = (e) => {
       const file = e.target.files[0];
       if (file) {
           const reader = new FileReader();
           reader.onloadend = () => {
               const img = new Image();
               img.onload = () => {
                   const canvas = document.createElement('canvas');
                   const targetWidth = isLogo ? 200 : 1200;
                   const targetHeight = isLogo ? 200 : 450;
                   
                   canvas.width = targetWidth;
                   canvas.height = targetHeight;
                   const ctx = canvas.getContext('2d');
                   
                   const scale = Math.max(targetWidth / img.width, targetHeight / img.height);
                   const scaledWidth = img.width * scale;
                   const scaledHeight = img.height * scale;
                   const x = (targetWidth - scaledWidth) / 2;
                   const y = (targetHeight - scaledHeight) / 2;
                   
                   ctx.fillStyle = '#ffffff';
                   ctx.fillRect(0, 0, targetWidth, targetHeight);
                   ctx.drawImage(img, x, y, scaledWidth, scaledHeight);
                   
                   const resizedImage = canvas.toDataURL('image/jpeg', 0.9);
                   setPreview(resizedImage);
                   onImageSelect(resizedImage);
               };
               img.src = reader.result;
           };
           reader.readAsDataURL(file);
       }
   };

   return (
       <Box sx={{ mb: 2 }}>
           <Box sx={{ 
               width: isLogo ? '50px' : 'auto',
               height: isLogo ? '50px' : 'auto',
               border: '2px dashed #ccc',
               borderRadius: isLogo ? '50%' : '4px',
               overflow: 'hidden',
               position: 'relative',
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               cursor: 'pointer',
               mx: 'auto'
           }}>
               {preview ? (
                   <>
                       <img 
                           src={preview} 
                           alt="Preview" 
                           style={{ 
                               width: '100%', 
                               height: '100%', 
                               objectFit: 'cover'
                           }} 
                       />
                       <Box sx={{
                           position: 'absolute',
                           top: 0,
                           left: 0,
                           right: 0,
                           bottom: 0,
                           backgroundColor: 'rgba(0,0,0,0.3)',
                           opacity: 0,
                           transition: '0.3s',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           '&:hover': {
                               opacity: 1
                           }
                       }}>
                           <IconButton
                               component="label"
                               sx={{ color: 'white' }}
                           >
                               <input
                                   hidden
                                   accept="image/*"
                                   type="file"
                                   onChange={handleFileSelect}
                               />
                               <PhotoCameraIcon />
                           </IconButton>
                       </Box>
                   </>
               ) : (
                   <Button
                       component="label"
                       variant="text"
                       sx={{ height: '100%', width: '100%' }}
                   >
                       <input
                           hidden
                           accept="image/*"
                           type="file"
                           onChange={handleFileSelect}
                       />
                       <Typography color="textSecondary" variant="body2">
                           {isLogo ? 'Logo' : 'Header'}
                       </Typography>
                   </Button>
               )}
           </Box>
           <Typography variant="caption" color="textSecondary" align="center" display="block" sx={{ mt: 1 }}>
               {isLogo ? 'Recommended: 200x200px' : 'Recommended: 1200x450px'}
           </Typography>
       </Box>
   );
}